import { render } from "./App.vue?vue&type=template&id=95a0b29e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=95a0b29e&lang=scss"

import exportComponent from "../../../../../../traveldesk-booking/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__